"use client";

import React from "react";
import Image from "next/image";

const AboutIndustry = ({
  points = [],
  imageSrc,
  imageAlt = "Industry collaborations",
  reverse = false,          
  className = "",
}) => {
  const Wrapper = imageSrc ? "section" : "div";

  return (
    <Wrapper className={`w-full bg-white ${className}`}>
      <div
        className={`grid gap-8 md:grid-cols-[minmax(0,1.1fr)_minmax(0,1fr)] items-start ${
          reverse ? "md:[&>div:first-child]:order-2 md:[&>div:last-child]:order-1" : ""
        }`}
      >
        {/* Points column */}
        <div>
          <div className="space-y-3">
            {points.map((item, idx) => (
              <div
                key={idx}
                className="flex items-center justify-between border border-[#0091E380] bg-white px-4 py-3 text-xs md:text-sm"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-7 w-7 items-center justify-center bg-white text-lg text-slate-800">
                    ✦
                  </span>
                  <span
                    className="text-slate-800"
                    style={{ fontFamily: "saans-regular" }}
                  >
                    {item}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </div>

        {imageSrc && (
          <div className="w-full h-full">
            <div className="relative h-[260px] sm:h-[320px] md:h-[360px] lg:h-[380px] w-full overflow-hidden bg-slate-100">
              <Image
                src={imageSrc}
                alt={imageAlt}
                fill
                priority
                className="object-cover"
              />
            </div>
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default AboutIndustry;
